import React, { Component } from 'react';

export default class BeforeAdditional extends Component {
  render() {
    return (
      <section className='additional'>
        <header className='additional__title'>
            Как это было?
        </header>

        <p className='additional__p'>
          Осень мы посвятили обзору веб- и мобайл-разработке. Разбавили айтишные доклады смежными направлениями и поговорили о веб-дизайне, менеджменте IT-проектов, стартапах и важности soft skills.
        </p>
        <p className='additional__p'>
          Участники узнали, чем занимаются IT-компании, какие знания нужны, чтобы попасть к ним, какие есть курсы, спецкурсы, конференции, стажировки и другие полезные IT-события в 2017-2018 учебном году.
        </p>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing/blocks/AfterAdditional.js